<template>
  <div class="results-pagination">
    <div class="page-controls">
      <button
        class="page-controls-button"
        :disabled="isFirstPage"
        :aria-label="paginationConfig.firstText"
        data-testid="first-page-button"
        @click="changePage(0, 'firstPage')"
      >
        <IconBack />
      </button>
      <button
        class="page-controls-button is-prev"
        :disabled="isFirstPage"
        :aria-label="paginationConfig.previousText"
        data-testid="previous-page-button"
        @click="changePage(currentPage - 1, 'previousPage')"
      >
        <IconChevronRight />
        <p>{{ paginationConfig.previousText }}</p>
      </button>
    </div>
    <p class="current-page-text">{{ currentPage + 1 }} / {{ numberOfPages }}</p>
    <div class="page-controls">
      <button
        class="page-controls-button is-next"
        :disabled="isLastPage"
        :aria-label="paginationConfig.nextText"
        data-testid="next-page-button"
        @click="changePage(currentPage + 1, 'nextPage')"
      >
        <p>{{ paginationConfig.nextText }}</p>
        <IconChevronRight />
      </button>
      <button
        class="page-controls-button is-last"
        :disabled="isLastPage"
        :aria-label="paginationConfig.lastText"
        data-testid="last-page-button"
        @click="changePage(numberOfPages, 'lastPage')"
      >
        <IconBack />
      </button>
    </div>
  </div>
</template>

<script>
import IconChevronRight from "../../Icons/IconChevronRight.vue";
import IconBack from "../../Icons/IconBack.vue";

export default {
  name: "ResultsPagination",
  components: { IconChevronRight, IconBack },
  props: {
    paginationConfig: {
      type: Object,
      required: true,
      default: () => {},
    },
    currentPage: {
      type: Number,
      required: true,
    },
    numberOfPages: {
      type: Number,
      required: true,
    },
    isFirstPage: {
      type: Boolean,
      required: true,
    },
    isLastPage: {
      type: Boolean,
      required: true,
    },
    changePageFunction: {
      type: Function,
      required: true,
    },
    scrollTarget: {
      type: String,
      default: "",
    },
  },
  emits: ["page-changed"],
  methods: {
    changePage(pageNumber, changeType) {
      this.changePageFunction(pageNumber);

      // Small timeout is necessary to only scroll after the new page is loaded and prevent stuttering due to remounting
      setTimeout(() => {
        if (this.scrollTarget) {
          document.querySelector(this.scrollTarget).scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);

      this.$emit("page-changed", changeType);
    },
  },
};
</script>

<style lang="scss" scoped>
.results-pagination {
  @include font-family("button");
  @include scale-fonts("button");

  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;

  padding: 25px 0;
}

.page-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.page-controls-button {
  @include reset-button;

  cursor: pointer;

  display: flex;
  gap: 5px;
  align-items: center;

  padding: 5px;

  transition: opacity 150ms ease;

  &:hover {
    opacity: 0.75;
  }

  &.is-prev {
    #icon-chevron-right {
      rotate: -180deg;
    }
  }

  &.is-next {
    @include mobile {
      text-align: right;
    }
  }

  &.is-last {
    #icon-back {
      rotate: -180deg;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  p {
    @include mobile {
      display: none;
    }
  }
}

.current-page-text {
  @include mobile {
    text-align: center;
    flex-basis: 100px;
  }
}
</style>
